import { createContext, useContext, type PropsWithChildren } from 'react';

export type DeviceType = {
    isProbablyAndroid: boolean;
    isProbablyIos: boolean;
    isProbablyTablet: boolean;
    isProbablyMobile: boolean;
    isProbablyMobileOrTablet: boolean;
};

export const defaultDeviceType: DeviceType = {
    isProbablyAndroid: true,
    isProbablyIos: false,
    isProbablyTablet: false,
    isProbablyMobile: true,
    isProbablyMobileOrTablet: true,
};

type Props = {
    deviceType?: DeviceType;
};

const DeviceTypeContext = createContext<DeviceType | undefined>(undefined);

export const DeviceTypeProvider = ({ deviceType = defaultDeviceType, children }: PropsWithChildren<Props>) => (
    <DeviceTypeContext.Provider value={deviceType}>{children}</DeviceTypeContext.Provider>
);

export const useDeviceType = (): DeviceType => {
    const context = useContext(DeviceTypeContext);
    if (!context) {
        return defaultDeviceType;
    }
    return context;
};
